import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { readSheetNames } from 'read-excel-file';
import { ConsigneeNotifierAdminService } from 'src/app/application/service/ConsigneeNotifierAdminService';
import { excelUtils } from 'src/app/ui/util/excel-utils';
import { formatUrl } from 'src/app/ui/util/file-formats';

@Component({
  selector: 'app-admin-uploads-consignees-notifiers',
  templateUrl: './admin-uploads-consignees-notifiers.component.html',
  styleUrls: ['./admin-uploads-consignees-notifiers.component.css'],
  providers: [ConfirmationService],
})
export class AdminUploadsConsigneesNotifiersComponent {
  excelFile: any;
  excelSheets: any;
  selectedSheet: string = '';
  loading: boolean = false;
  loadingExport: boolean = false;
  uploadFile: any[] = [];
  uploadFormatUrl: string = formatUrl.consignee_notifier_admin_format;
  uploadDisabled: boolean = true;

  constructor(
    private _messageService: MessageService,
    private translate: TranslateService,
    private _consigneeNotifierAdminService: ConsigneeNotifierAdminService
  ) {}

  sendFiles() {
    this.loading = true;
    if (this.uploadFile[0]) {
      const request: any = {
        file: this.uploadFile[0],
      };

      this._consigneeNotifierAdminService
        .uploadConsigneesNotifiers(request)
        .subscribe({
          next: (v) => {
            this._messageService.add({
              severity: 'success',
              summary: this.translate.instant(
                'MessageService.Summary.SuccessAction'
              ),
              detail: 'Consignees y Notifiers cargados exitosamente',
            });
            this.loading = false;
          },
          error: (e) => {
            this.loading = false;
            let errorMessage = '';
            const lang = this.translate.currentLang;
            switch (lang) {
              case 'es':
                errorMessage = e.error.messageEs;
                break;
              case 'en':
                errorMessage = e.error.messageEn;
                break;
              default:
                errorMessage = 'Error al cargar consignees y notifiers';
            }
            this._messageService.add({
              severity: 'error',
              summary: this.translate.instant(
                'MessageService.Summary.FailedAction'
              ),
              detail: errorMessage,
            });
          },
          complete: () =>
            console.info('Consigness and Notifiers created successfully'),
        });
    } else {
      this._messageService.add({
        severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.FailFileAction'),
      });
      this.loading = false;
    }
  }

  exportConsigneesNotifiers() {
    this.loadingExport = true;
    this._consigneeNotifierAdminService.exportConsigneesNotifiers().subscribe({
      next: (resultBlob) => {
        excelUtils.downloadExcel(resultBlob.body, 'consignees_notifiers');
        this.loadingExport = false;
      },
      error: (e) => {
        this.loadingExport = false;
        this._messageService.add({
          severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: 'Error al descargar consignees y notifiers',
        });
      },
    });
  }

  onSelect(event: any, uploader: any) {
    this.uploadFile = uploader.files;
    if (this.uploadFile.length > 0) {
      this.uploadDisabled = false;
    } else {
      this.uploadDisabled = true;
    }
  }

  onRemove(event: any, uploader: any) {
    this.uploadFile = uploader.files;
    if (this.uploadFile.length > 0) {
      this.uploadDisabled = false;
    } else {
      this.uploadDisabled = true;
    }
  }

  onClear(event: any, uploader: any) {
    this.uploadFile = uploader.files;
    if (this.uploadFile.length > 0) {
      this.uploadDisabled = false;
    } else {
      this.uploadDisabled = true;
    }
  }
}
